/**
 * @ngdoc services
 * @memberof mercury.modules.time
 * @name TimePayrollPayruns
 * @description Data access service for managing payruns
 */
angular.module('mercury.modules.time.payroll.payrun')
.factory('TimePayrollPayruns', ["$q", "$resource", "$window", "settings", function($q, $resource, $window, settings) {
  var Payruns = $resource(settings.apiHost + '/r/TimePayrollPayruns/:id', {id: '@id'}, {patch: {method: 'PATCH'}});
  var PayrunLines = $resource(settings.apiHost + '/r/TimePayrollPayrunLines/:id', {id: '@id'});

  /**
   * Get a summary of outstanding payruns
   *
   * @memberof TimePayrollPayruns
   */
  function getOutstanding() {
    return Payruns.query({$filter: 'DatestampApproved eq null'}).$promise;
  }

  /**
   * Get a summary of approved payruns in the given time range
   *
   * @memberof TimePayrollPayruns
   * @param  {Object} startTime Start of range
   * @param  {Object} endTime   End of range
   */
  function getArchive(startTime, endTime) {
    return Payruns.query({
      $filter: 'DatestampStart lt ' + endTime + ' and DatestampEnd ge ' + startTime +
        ' and DatestampApproved ne null'
    }).$promise;
  }

  /**
   * Get the full model of a specific payrun
   *
   * @memberof TimePayrollPayruns
   * @param  {String} id Id of the payrun
   */
  function get(id) {
    return Payruns.get({id: id}).$promise;
  }

  /**
   * Get a new payrun for the given period but don't save it to the database
   *
   * @memberof TimePayrollPayruns
   * @param  {String} start   Start of payrun period
   * @param  {String} end     End of payrun period
   * @param  {String} payment Payment date for payrun
   * @param  {String} freq    Frequency type for payrun
   */
  function getNew(start, end, payment, freq) {
    return Payruns.get({
      datestampStart: start,
      datestampEnd: end,
      datestampPayment: payment,
      frequency: freq
    }).$promise;
  }

  /**
   * Get a new payrun line for the given period but don't save it to the database
   *
   * @memberof TimePayrollPayruns
   * @param  {String} start         Start of payrun period
   * @param  {String} end           End of payrun period
   * @param  {String} staffMemberId Id of the staff member the payrun line is for.
   */
  function getNewLine(start, end, staffMemberId) {
    return PayrunLines.get({datestampStart: start, datestampEnd: end, staffMemberId: staffMemberId}).$promise;
  }

  /**
   * Get a summary of the last payrun
   *
   * @memberof TimePayrollPayruns
   */
  function getLast() {
    return Payruns.query({
      $orderby: 'DatestampStart desc',
      $top: 1
    }).$promise;
  }

  /**
   * Create a payrun in the database
   *
   * @memberof TimePayrollPayruns
   * @param  {Object} payrun New payrun model
   */
  function create(payrun) {
    delete payrun.id;
    return Payruns.save(payrun).$promise;
  }

  /**
   * Update a payrun
   *
   * @memberof TimePayrollPayruns
   * @param  {Object} payrun Updated payrun model
   */
  function update(payrun) {
    return Payruns.update(payrun).$promise;
  }

  /**
   * Set the given payrun as deleted
   *
   * @memberof TimePayrollPayruns
   * @param  {Object} payrun Model of payrun
   */
  function remove(payrun) {
    var delta = [{op: 'replace', path: 'DatestampDeleted', value: moment().format()}];

    return Payruns.patch({id: payrun.id}, delta).$promise;
  }

  /**
   * Set the given payrun as approved
   *
   * @memberof TimePayrollPayruns
   * @param  {Object} payrun Model of payrun
   */
  function approve(payrun) {
    var delta = [{op: 'replace', path: 'DatestampApproved', value: moment().format()}];

    return Payruns.patch({id: payrun.id}, delta).$promise;
  }

  /**
   * Download the specific payrun in a specific payrun format.
   *
   * @memberof TimePayrollPayruns
   * @param  {String} id           Id of payrun to export
   * @param  {Boolean} includeStaff Should staff be included in the export
   */
  function downloadExport(id, includeStaff) {
    var promise = Payruns.get({
      id: id,
      includeStaff: includeStaff,
      format: 'AcePayroll'
    }).$promise;

    promise.then(function(result) {
      $window.location.assign(result.location);
    });

    return promise;
  }

  return {
    getOutstanding: getOutstanding,
    getArchive: getArchive,
    get: get,
    getNew: getNew,
    getNewLine: getNewLine,
    getLast: getLast,
    create: create,
    update: update,
    remove: remove,
    approve: approve,
    downloadExport: downloadExport
  };
}]);
